//import * as lib from '../lib/lib'
import $ from 'jquery'

class ReadMore {
  constructor(element) {
    if (!element) return

    this.element = element
    this.wrap = $(element)

    // this.iniCollapsedBtn()
  
    this.iniVars()
    this.addTruncate()
    this.showToggler()
    this.handleToggler()
    this.handleTogglerLess()

    $(window).on("resize", ()=>{
        this.iniVars()
        this.addTruncate()
        this.showToggler()
    })
  }

  iniVars() {
    this.firstItem = this.wrap.find('.b-disclaimer__item:first .b-disclaimer__txt').height()
    this.lengthOfItems = this.wrap.find('.b-disclaimer__item').length
    this.showLess = this.wrap.find(".b-disclaimer__toggle__less")
    this.showMore = this.wrap.find(".b-disclaimer__toggle__more")
  }

  addTruncate() {
    if (this.firstItem > 140) {       
        this.wrap.find('.b-disclaimer__item:first .b-disclaimer__txt').addClass('truncate')
    }
  }

  showToggler(){
    if(this.firstItem > 140 ||  this.lengthOfItems > 1){   
        this.wrap.addClass("showToggler")
    }else{
        this.wrap.removeClass("showToggler")       
    }
  }

  handleToggler(){
    this.showMore.click((e)=>{
        const $item = $(e.currentTarget)
        $item.toggleClass("hide")
        this.showLess.toggleClass("hide")
        this.wrap.find('.b-disclaimer__item:first .b-disclaimer__txt').removeClass('truncate')
       
        this.wrap.find('.b-disclaimer__item:not(:first)').slideDown()
    })
  }

  handleTogglerLess(){
    this.showLess.click((e)=>{
        const $item = $(e.currentTarget)
        $item.toggleClass("hide")
        this.showMore.toggleClass("hide")
        this.wrap.find('.b-disclaimer__item:first .b-disclaimer__txt').addClass('truncate')
       
        this.wrap.find('.b-disclaimer__item:not(:first)').slideUp()
    })
  }
}

export default ReadMore
